export default __webpack_public_path__ + "assets/png/6236b2224d4ebbdc642a142e977b93cc.png";